<template>
  <form class="form-create-bonus-card__form" v-on:submit.prevent="submit">
    <div class="form-create-bonus-card__header">
      <span class="form-create-bonus-card__title-number">Новая бонусная карта </span>
      <label class="form-create-bonus-card__field-number">
        <span>№</span>
        <input
          v-model="bonusCard.number"
          class="form-create-bonus-card__input input-number"
          name="card-number"
          type="number"
        >
      </label>
    </div>
    <p
      v-for="violationText in cardNumberErrors"
      v-bind:key="violationText"
      class="form-create-bonus-card__violation"
      role="alert"
    >{{ violationText }}</p>
    <div class="form-create-bonus-card__form">
      <div class="form-create-bonus-card__balance">
        <label class="form-create-bonus-card__label">
          <div>
            Текущий баланс
            <help-icon
              class="form-create-bonus-card__help"
              v-bind:tooltip-text="$options.helpText"
              v-bind:sizes="{ width: 22, height: 22 }"
            />
          </div>
          <input
            v-model="bonusCard.amount"
            class="form-create-bonus-card__input amount"
            name="card-amount"
            type="number"
            v-on:focus="onFocusBonusAmount"
          />
        </label>
        <p
          v-for="violationText in amountErrors"
          v-bind:key="violationText"
          class="form-create-bonus-card__violation"
          role="alert"
        >{{ violationText }}</p>
      </div>
    </div>
    <div>
      <button class="form-create-bonus-card__button submit" type="submit">Выпустить</button>
    </div>
  </form>
</template>

<script>
import { BonusCard } from '@/mixins/loyaltySystemMixin';
import HelpIcon from '@/components/HelpIcon.vue';

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.violations ? vm.violations[cause] : []
);

/**
 * @description Текст кнопки помощи.
 * @type {string}
 */
const helpText = 'Укажите количество бонусов, начисленных ранее';

export default {
  /**
   * @description Форма создания бонусной карты
   */
  name: 'FormCreateBonusCard',
  components: { HelpIcon },
  computed: {
    bonusCard: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    /**
     * @description Ошибки номера карты
     * @type {Array}
     */
    cardNumberErrors: resolveInputErrors('bonus_card.card-number'),
    /**
     * @description Нарушение в поле сумма бонусов.
     * @type {Array}
     */
    amountErrors: resolveInputErrors('bonus_card.amount'),
  },
  data() {
    return {
      isNumberFieldFocused: false,
    };
  },
  methods: {
    /**
     * @description Обработать событие фокусировки
     * @returns {void}
     */
    onFocusBonusAmount() {
      this.bonusCard.amount = this.bonusCard.amount.toString()
        .replace(/^0$/, '');
    },
    /**
     * @description Отправить форму
     * @returns {void}
     */
    submit() {
      this.$emit('submit');
    },
  },
  props: {
    value: {
      type: BonusCard,
      required: true,
    },
    /**
     * @description Нарушения
     * @type {Object}
     */
    violations: {
      type: Object,
      required: true,
    },
  },
  helpText,
};
</script>

<style lang="scss" scoped>
@use "@/scss/buttons";

.form-create-bonus-card {
  &__title-number {
    font-size: 24px;
    font-weight: bold;
    color: #1b232d;
  }
  &__field-number {
    font-size: 24px;
    font-weight: bold;
    color: var(--action-color);
    white-space: nowrap;
  }
  &__violation {
    color: var(--warning-color);
    font-size: 12px;
    line-height: 14px;
    font-weight: 400;
    padding: .125rem;
  }
  &__form {
    margin: 25px 0;
  }
  &__button {
    &.submit {
      @include buttons.btn-blue(100%, 48px, 16px);
    }
  }
  &__label {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px 10px;
    font-size: 18px;
    color: var(--reading-color);
  }
  &__input {
    padding: 5px;
    border-radius: 4px;
    &.amount {
      max-width: 100px;
      padding-block: 8px;
      font-size: 18px;
      color: var(--reading-color);
      border: 1px solid var(--action-color);
      &:focus-visible {
        color: #212529;
        outline: 0;
      }
    }
    &.input-number {
      max-width: 120px;
      padding-left: 0;
      font-size: 24px;
      color: var(--action-color);
      font-weight: bold;
      border: 1px solid transparent;
      &:focus-visible {
        padding-left: 5px;
        border-color: var(--action-color);
        outline: 0;
      }
    }
  }
  &__help {
    align-self: flex-start;
    margin-block: 0;
  }
}

@media screen and (max-width: 420px) {
  .form-create-bonus-card {
    &__label {
      flex-direction: column;
      align-items: flex-start;
    }
  }
}
</style>
